import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
  Button,
} from "@mui/material";
import { useRef, useEffect, useState } from "react";
import * as fabric from "fabric"; // For Fabric.js v6+
import { useSnackbar } from "notistack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TaskIcon from "@mui/icons-material/Task";

const ImagesDraw = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const canvasRef = useRef(null);
  const fabricRef = useRef(null); // Ref to store the fabric canvas instance

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initCanvas = async () => {
      // 1. Initialize Canvas
      await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for the component to mount
      if (canvasRef.current) {
        // 2. Load and set Background Image (v6 Promise syntax)
        const img = await fabric.FabricImage.fromURL(props.imageUrl, {
          crossOrigin: "anonymous",
        });

        // 2. Set origins to center so (left, top) refers to the image's center
        img.set({
          originX: "center",
          originY: "center",
          left: img.width / 2,
          top: img.height / 2,
          // crossOrigin: "anonymous",
          selectable: false, // Ensure users can't accidentally move it
        });

        const canvas = new fabric.Canvas(canvasRef.current, {
          isDrawingMode: true,
          width: img.width,
          height: img.height,
        });

        // Optional: Scale image to fit canvas if dimensions differ
        // img.scaleToWidth(canvas.width);

        canvas.backgroundImage = img;

        // 3. Configure Brush
        canvas.freeDrawingBrush = new fabric.PencilBrush(canvas);
        canvas.freeDrawingBrush.width = 5;
        canvas.freeDrawingBrush.color = "#ff0000";

        canvas.renderAll();
        fabricRef.current = canvas;
        setIsLoading(false);
      }
    };

    if (isLoading) {
      initCanvas();
    }

    return () => {
      if (fabricRef.current) fabricRef.current = null;
    };
  }, []);

  const onCanvasClick = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    console.log("Canvas clicked at:", x, y);
  };

  const onCompleteClick = async () => {
    await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for the component to mount
    if (fabricRef.current) {
      const dataUrl = fabricRef.current.toDataURL({
        format: "png",
        multiplier: 1, // No scaling
      });
      props.onDrawComplete(props.drawId, dataUrl);
      props.onDrawClose();
    } else {
      enqueueSnackbar("Drawing canvas is not ready.", {
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
        variant: "error",
      });
    }
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"lg"}
      open={props.isDrawOpen}
      onClose={props.onDrawClose}
      scroll={"paper"}
    >
      <DialogTitle style={{ paddingTop: 0, paddingBottom: 0 }}>
        {"Image Draw Tool"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {"Click and drag on the image to draw on it."}
        </DialogContentText>

        <Box
          noValidate
          // component="form"
          // sx={{
          //   // display: "flex",
          //   flexDirection: "column",
          //   m: "auto",
          //   width: "100%",
          //   flexGrow: 1,
          // }}
        >
          <canvas
            // style={{ maxWidth: "50%", maxHeight: "50%" }}
            ref={canvasRef}
            onClick={onCanvasClick}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        {/* <Stack direction="row" spacing={2}> */}
        <Button startIcon={<ArrowBackIcon />} onClick={props.onDrawClose}>
          Cancel
        </Button>

        <Button
          startIcon={<TaskIcon />}
          variant="contained"
          onClick={onCompleteClick}
        >
          Sketch Complete
        </Button>
        {/* </Stack> */}
      </DialogActions>
    </Dialog>
  );
};

export default ImagesDraw;
